import * as d3 from 'd3';
import { Theme } from '@mui/material';
import { ChartScales, ChartLayout } from '../types';

interface BrushConfig {
    scales: ChartScales;
    layout: ChartLayout;
    theme: Theme;
    onDateRangeChange: (startDate: Date, endDate: Date) => void;
}

interface MouseHandlers {
    handleMouseMove: (this: Element, event: MouseEvent) => void;
    handleMouseOut: () => void;
}

export function setupBrush(
    g: d3.Selection<SVGGElement, unknown, null, undefined>,
    config: BrushConfig,
    mouseHandlers: MouseHandlers
): void {
    const { scales, layout, theme, onDateRangeChange } = config;
    const { handleMouseMove, handleMouseOut } = mouseHandlers;

    const brush = d3.brushX()
        .extent([[0, 0], [layout.innerWidth, layout.totalChartHeight]]);

    const brushGroup = g.append('g')
        .attr('class', 'brush')
        .call(brush);

    brush.on('end', (event) => {
        const selection = event.selection;
        if (selection && selection[0] !== selection[1]) {
            const [x0, x1] = selection as [number, number];
            onDateRangeChange(scales.x.invert(x0), scales.x.invert(x1));
            brushGroup.call(brush.move, null);
        }
    });

    brushGroup.select('.selection')
        .style('fill', theme.palette.primary.main)
        .style('fill-opacity', 0.2)
        .style('stroke', theme.palette.primary.main)
        .style('stroke-width', 1);

    brushGroup.select('.overlay')
        .style('pointer-events', 'all')
        .on('mousemove', handleMouseMove as any)
        .on('mouseout', handleMouseOut);
}

export function setupInteractiveOverlay(
    g: d3.Selection<SVGGElement, unknown, null, undefined>,
    layout: ChartLayout,
    mouseHandlers: MouseHandlers,
    hasBrush: boolean
): void {
    const { handleMouseMove, handleMouseOut } = mouseHandlers;

    // Interactive overlay for tooltips (disabled when brush is active)
    g.append('rect')
        .attr('width', layout.innerWidth)
        .attr('height', layout.totalChartHeight)
        .attr('fill', 'transparent')
        .attr('pointer-events', hasBrush ? 'none' : 'all')
        .on('mousemove', handleMouseMove)
        .on('mouseout', handleMouseOut);
}
